// extracted by mini-css-extract-plugin
module.exports = {"TagActive":"spaw_TagActive__Qywfh","TagExpired":"spaw_TagExpired__JW6xS","Banner":"spaw_Banner__YyMQO","Headline":"spaw_Headline__nMkUB","link":"spaw_link__HPd2E"};